export default __webpack_public_path__ + "static/media/gallery_04.a9c94e5d.jpg";